<template>
  <BaseModal
    :class="bemBlock"
    :is-open="true"
    :modal-modifier="'pdp'"
    :show-backdrop="true"
    @closed="$emit('in-store-stock-modal-closed')"
  >
    <div :class="bemElement('content-aside')">
      <BaseImage
        v-if="isBreakpointDesktop"
        :class="bemElement('pic-aside')"
        loading="eager"
        :image="getDefaultImageFromProductImageSet(mainImage)"
        :placeholder="getPlaceholderImageFromProductImageSet(mainImage)"
        :sizes="imageAttributeSizes.IN_STORE_STOCK"
        :srcset="getSrcsetFromProductImageSet(mainImage)"
      />
    </div>
    <div :class="[bemElement('main-content'), 'overflow']">
      <h1 :class="[bemElement('title'), 'the-product-details__title']">
        {{ $msg('instorestock.title', 'inStoreStock') }}
      </h1>
      <p :class="bemElement('subtitle')">
        {{ subtitle }}
      </p>
      <TheInStoreStockModalSizeSelector
        v-if="!isSizeSelected"
        :product="product"
        @size:confirm="(confirmedSizes) => (selectedSizes = confirmedSizes)"
      />
      <BaseStoreLocator v-else :url="storeLocatorUrl" />
    </div>
  </BaseModal>
</template>

<script>
import { urlWithSearchParams } from '../../common/utils/url';
import bemClassesMixin from '../mixins/bemClassesMixin';
import { productBaseMixin } from '../mixins/productPropBaseMixin';
import { productImageSetMixin } from '../mixins/productImageSetMixin';
import productPropSizesMixin from '../mixins/productPropSizesMixin';
import windowResizeMixin from '../mixins/windowResizeMixin';
import BaseImage from './BaseImage.vue';
import BaseModal from './BaseModal.vue';
import BaseStoreLocator from './BaseStoreLocator.vue';
import TheInStoreStockModalSizeSelector from './TheInStoreStockModalSizeSelector.vue';
import getAnalyticsEventBus from '../../common/getAnalyticsEventBus';
import getFrontConfig from '../../common/getFrontConfig';
import { getVariationGroupId } from '../../common/helpers/productIdHelpers';

const analyticsEventBus = getAnalyticsEventBus();

const {
  productImages: {
    imageSets: { PLAIN },
  },
  responsive: { bp_1025: bp1025 },
  urls: { inStoreStock },
} = getFrontConfig();

const SIZES = {
  IN_STORE_STOCK: '24vw',
};

export default {
  name: 'TheInStoreStockModal',

  components: {
    BaseImage,
    BaseModal,
    BaseStoreLocator,
    TheInStoreStockModalSizeSelector,
  },

  mixins: [
    bemClassesMixin,
    productBaseMixin,
    productImageSetMixin,
    productPropSizesMixin,
    windowResizeMixin,
  ],

  data: () => ({
    dataChangeBreakpoint: bp1025,
    selectedSizes: [],
    imageAttributeSizes: SIZES,
    pid: '',
  }),

  computed: {
    isSizeSelected() {
      return this.hasUniqueSize() || this.selectedSizes.length > 0;
    },
    mainImage() {
      return this.getProductImageSets(PLAIN)?.[0];
    },
    skuList() {
      const list = [];
      this.selectedSizes.forEach((size) => {
        list.push(`${this.pid}${size.value}`);
      });
      return list.join(',');
    },
    storeLocatorUrl() {
      return urlWithSearchParams(inStoreStock, {
        filterByDroppoint: false,
        filterByMarketplace: false,
        visibleInStoreFinder: true,
        sku: this.skuList,
      });
    },
    subtitle() {
      return !this.isSizeSelected
        ? this.$msg('instorestock.subtitle.size', 'inStoreStock')
        : this.$msg('instorestock.subtitle.storeLocator', 'inStoreStock');
    },
  },

  mounted() {
    this.pid = getVariationGroupId(this.product.id);
    if (this.hasUniqueSize()) {
      this.selectedSizes.push(this.getUniqueSize());
    }
    // Send info for Analytics
    analyticsEventBus.publish(
      analyticsEventBus.EVENTS.productDetailsItemClicked,
      analyticsEventBus.EVENTS.PAYLOADS.productDetailsItemClicked.item
        .inStoreStock
    );
  },
};
</script>
